export default "__VITE_ASSET__Cykc8l_0__"